export default "__VITE_ASSET__60a44465__"